import Renderer from "@wielink/datatables/Renderers/Renderer";

class ConceptRenderer extends Renderer {
	render() {
		if (this.row.is_concept) {
			return 'Ja';
		}
		return 'Nee';
	}
}

export default ConceptRenderer;